<template>
  <div class="page-header">
    <div class="header-wrapper row m-0">
      <form class="form-inline search-full col" action="#" method="get">
        <div class="form-group w-100">
          <div class="Typeahead Typeahead--twitterUsers">
            <div class="u-posRelative">
              <input class="demo-input Typeahead-input form-control-plaintext w-100" type="text"
                placeholder="Search Riho .." name="q" title="" autofocus>
              <div class="spinner-border Typeahead-spinner" role="status"><span class="sr-only">Loading... </span></div>
              <i class="close-search" data-feather="x"></i>
            </div>
            <div class="Typeahead-menu"> </div>
          </div>
        </div>
      </form>
      <div class="header-logo-wrapper col-auto p-0">
        <div class="logo-wrapper"> <a href="/">
            <img class="img-fluid for-light" src="../../assets/images/logo/logo_dark.png" alt="logo-light">
            <img class="img-fluid for-dark" src="../../assets/images/logo/logo.png" alt="logo-dark"></a></div>
        <div class="toggle-sidebar"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-align-center status_toggle middle sidebar-toggle">
            <line x1="18" y1="10" x2="6" y2="10"></line>
            <line x1="21" y1="6" x2="3" y2="6"></line>
            <line x1="21" y1="14" x2="3" y2="14"></line>
            <line x1="18" y1="18" x2="6" y2="18"></line>
          </svg></div>
      </div>
      <div class="left-header col-xxl-5 col-xl-6 col-lg-5 col-md-4 col-sm-3 p-0">
        <div> <a class="toggle-sidebar" href="#"> <i class="iconly-Category icli"> </i></a>
          <div class="d-flex align-items-center gap-2 ">
            <h4 class="f-w-600">Hello {{ emp.empname }}</h4><img class="mt-0" src="../../assets/images/hand.gif"
              alt="hand-gif">
          </div>
        </div>
        <div class="welcome-content d-xl-block d-none"><span class="text-truncate col-12">HD Hyundai Wishes You Have a
            Nice Day. </span></div>
      </div>
      <div class="nav-right col-xxl-7 col-xl-6 col-md-7 col-8 pull-right right-header p-0 ms-auto">
        <ul class="nav-menus">
          <li class="d-md-block d-none">
            <div class="form search-form mb-0">
              <div class="input-group"><span class="input-icon">
                  <svg>
                    <use href="../../assets/svg/icon-sprite.svg#search-header"></use>
                  </svg>
                  <input class="w-100" type="search" placeholder="Search"></span></div>
            </div>
          </li>
          <li class="d-md-none d-block">
            <div class="form search-form mb-0">
              <div class="input-group"> <span class="input-show">
                  <svg id="searchIcon">
                    <use href="../../assets/svg/icon-sprite.svg#search-header"></use>
                  </svg>
                  <div id="searchInput">
                    <input type="search" placeholder="Search">
                  </div>
                </span></div>
            </div>
          </li>
          <li class="onhover-dropdown">
            <svg>
              <use href="../../assets/svg/icon-sprite.svg#star"></use>
            </svg>
            <div class="onhover-show-div bookmark-flip">
              <div class="flip-card">
                <div class="flip-card-inner">
                  <div class="front">
                    <h6 class="f-18 mb-0 dropdown-title">Bookmark</h6>
                    <ul class="bookmark-dropdown">
                      <li>
                        <div class="row">
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="file-text"></i></div><span>Forms</span>
                            </div>
                          </div>
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="user"></i></div><span>Profile</span>
                            </div>
                          </div>
                          <div class="col-4 text-center">
                            <div class="bookmark-content">
                              <div class="bookmark-icon"><i data-feather="server"></i></div><span>Tables</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="text-center"><a class="flip-btn f-w-700" id="flip-btn" href="javascript:void(0)">Add
                          New Bookmark</a></li>
                    </ul>
                  </div>
                  <div class="back">
                    <ul>
                      <li>
                        <div class="bookmark-dropdown flip-back-content">
                          <input type="text" placeholder="search...">
                        </div>
                      </li>
                      <li><a class="f-w-700 d-block flip-back" id="flip-back" href="javascript:void(0)">Back</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="mode"><i class="moon" data-feather="moon"> </i></div>
          </li>
          <li class="onhover-dropdown notification-down">
            <div class="notification-box">
              <svg>
                <use href="../../assets/svg/icon-sprite.svg#notification-header"></use>
              </svg><span class="badge rounded-pill badge-secondary">{{ notifications.length || 0 }} </span>
            </div>
            <div class="onhover-show-div notification-dropdown">
              <div class="card mb-0">
                <div class="card-header">
                  <div class="common-space">
                    <h4 class="text-start f-w-600">Notifications</h4>
                    <div><span>{{ notifications.length }} New</span></div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="notitications-bar">
                    <ul class="nav nav-pills nav-primary p-0" id="pills-tab" role="tablist">
                      <li class="nav-item p-0">
                        <a class="nav-link" :class="{ active: activeTab === 'all' }" id="pills-aboutus-tab"
                          @click="setActiveTab('all')" href="#pills-aboutus" role="tab" aria-controls="pills-aboutus"
                          aria-selected="true">
                          All({{ notifications.length }})
                        </a>
                      </li>
                      <li class="nav-item p-0">
                        <a class="nav-link" :class="{ active: activeTab === 'employee' }" id="pills-employees-tab"
                          @click="setActiveTab('employee')" href="#pills-employees" role="tab"
                          aria-controls="pills-employees" aria-selected="false">
                          Employee
                        </a>
                      </li>
                      <li class="nav-item p-0">
                        <a class="nav-link" :class="{ active: activeTab === 'visitor' }" id="pills-visitor-tab"
                          @click="setActiveTab('visitor')" href="#pills-visitor" role="tab"
                          aria-controls="pills-visitor" aria-selected="false">
                          Visitor
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content" id="pills-tabContent">
                      <div class="tab-pane fade" :class="{ 'show active': activeTab === 'all' }" id="pills-aboutus"
                        role="tabpanel" aria-labelledby="pills-aboutus-tab">
                        <div class="user-message" v-if="notifications.length > 0">
                          <ul>
                            <li v-for="(notification, index) in notifications" :key="index">
                              <div class="user-alerts">
                                <div
                                  class="user-image rounded-circle img-fluid me-2 d-flex align-items-center justify-content-center text-white"
                                  :class="notification.employee_name && notification.employee_name.trim() !== '' ? 'bg-primary' : 'bg-secondary'"
                                  style="width: 40px; height: 40px; font-size: 16px;">
                                  {{ getInitial(notification) }}
                                </div>
                                <div class="user-name">
                                  <div>
                                    <h6><a class="f-w-500 f-14" href="../template/user-profile.html">
                                        {{ getDisplayName(notification) }}
                                      </a></h6>
                                    <span class="f-light f-w-500 f-12">Gatepass ID: {{ notification.gatepassid ||
                                      notification.id }}</span>
                                  </div>
                                  <div>
                                    <svg>
                                      <use href="../../assets/svg/icon-sprite.svg#more-vertical"></use>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-center py-3">
                          <p>No notifications available</p>
                        </div>
                      </div>
                      <!-- Employee notification section with contact instead of gatepass ID -->
                      <div class="tab-pane fade" :class="{ 'show active': activeTab === 'employee' }"
                        id="pills-employees" role="tabpanel" aria-labelledby="pills-employees-tab">
                        <div class="user-message" v-if="employeeNotifications.length > 0">
                          <ul>
                            <li v-for="(notification, index) in employeeNotifications" :key="index">
                              <div class="user-alerts">
                                <div
                                  class="user-image rounded-circle img-fluid me-2 d-flex align-items-center justify-content-center bg-primary text-white"
                                  style="width: 40px; height: 40px; font-size: 16px;">
                                  {{ notification.employee_name ? notification.employee_name.charAt(0).toUpperCase() :
                                    'U' }}
                                </div>
                                <div class="user-name">
                                  <div>
                                    <h6><a class="f-w-500 f-14" href="../template/user-profile.html">{{
                                      notification.employee_name }}</a></h6>
                                    <span class="f-light f-w-500 f-12">Contact: {{ notification.employee_contact ||
                                      'N/A' }}</span>
                                  </div>
                                  <div>
                                    <svg>
                                      <use href="../../assets/svg/icon-sprite.svg#more-vertical"></use>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-center py-3">
                          <p>No employee notifications</p>
                        </div>
                      </div>
                      <!-- Visitor notification section with images -->
                      <div class="tab-pane fade" :class="{ 'show active': activeTab === 'visitor' }" id="pills-visitor"
                        role="tabpanel" aria-labelledby="pills-visitor-tab">
                        <div class="user-message" v-if="visitorNotifications.length > 0">
                          <ul>
                            <li v-for="(notification, index) in visitorNotifications" :key="index">
                              <div class="user-alerts">
                                <!-- Add visitor image if available, otherwise use initials -->
                                <div v-if="notification.visitor_image" class="user-image me-2"
                                  style="width: 40px; height: 40px;">
                                  <img class="rounded-circle img-fluid"
                                    :src="getVisitorImagePath(notification.visitor_image)" alt="Visitor Image"
                                    style="width: 100%; height: 100%; object-fit: cover;">
                                </div>
                                <div v-else
                                  class="user-image rounded-circle img-fluid me-2 d-flex align-items-center justify-content-center bg-secondary text-white"
                                  style="width: 40px; height: 40px; font-size: 16px;">
                                  {{ notification.visitor_name ? notification.visitor_name.charAt(0).toUpperCase() : 'V'
                                  }}
                                </div>
                                <div class="user-name">
                                  <div>
                                    <h6><a class="f-w-500 f-14" href="../template/user-profile.html">{{
                                      notification.visitor_name || 'Visitor' }}</a></h6>
                                    <span class="f-light f-w-500 f-12">{{ notification.visitor_contact ||
                                      notification.visitor_firm || 'Visitor' }}</span>
                                  </div>
                                  <div>
                                    <svg>
                                      <use href="../../assets/svg/icon-sprite.svg#more-vertical"></use>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div v-else class="text-center py-3">
                          <p>No visitor notifications</p>
                        </div>
                      </div>
                      <div class="card-footer pb-0 pr-0 pl-0">
                        <div class="text-center">
                          <a class="f-w-700" href="javascript:void(0)" @click="checkAllNotifications">
                            <button class="btn btn-primary" type="button" title="btn btn-primary">Check all</button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="profile-nav onhover-dropdown">
            <div class="media profile-media"><img class="b-r-10" src="../../assets/images/dashboard/profile.png" alt="">
              <div class="media-body d-xxl-block d-none box-col-none">
                <div class="d-flex align-items-center gap-2"> <span>{{ emp.empname }} </span><i
                    class="middle fa fa-angle-down"> </i></div>
                <p class="mb-0 font-roboto" v-if="emp.emprole == 1">ADMIN</p>
                <p class="mb-0 font-roboto" v-else-if="emp.emprole == 2">HOD</p>
                <p class="mb-0 font-roboto" v-else-if="emp.emprole == 3">Employee</p>
              </div>
            </div>
            <ul class="profile-dropdown onhover-show-div">
              <li><router-link to="/profile"><i data-feather="user"></i><span>My Profile</span></router-link></li>

              <li><a class="btn btn-pill btn-outline-primary btn-sm" @click="logout()">Log Out</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Page Sidebar Start-->
  <div class="sidebar-wrapper" data-layout="stroke-svg">
    <div class="logo-wrapper"><a href="/"><img class="img-fluid" src="../../assets/images/logo/logo.png" alt=""></a>
      <div class="back-btn"><i class="fa fa-angle-left"> </i></div>
      <div class="toggle-sidebar" @click="sidebar_btn" checked="checked"><svg xmlns="http://www.w3.org/2000/svg"
          width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-grid status_toggle middle sidebar-toggle">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        </svg></div>
    </div>
    <div class="logo-icon-wrapper"><a href="/"><img class="img-fluid" src="../../assets/images/logo/logo-icon.png"
          alt=""></a></div>
    <nav class="sidebar-main">
      <div class="left-arrow" id="left-arrow"><i data-feather="arrow-left"></i></div>
      <div id="sidebar-menu">
        <ul class="sidebar-links" id="simple-bar" data-simplebar="init" style="display: block;">
          <div class="simplebar-wrapper" style="margin: 0px;">
            <div class="simplebar-height-auto-observer-wrapper">
              <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
              <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                <div class="simplebar-content-wrapper" style="height: 100%; overflow: hidden scroll;">
                  <div class="simplebar-content" style="padding: 0px;">
                    <li class="back-btn"><a href="/"><img class="img-fluid" src="../../assets/images/logo/logo-icon.png"
                          alt=""></a>
                      <div class="mobile-back text-end"> <span>Back </span><i class="fa fa-angle-right ps-2"
                          aria-hidden="true"></i></div>
                    </li>
                    <li class="pin-title sidebar-main-title">
                      <div>
                        <h6>Pinned</h6>
                      </div>
                    </li>
                    <li class="sidebar-main-title">
                      <div>
                        <h6 class="lan-1">General</h6>
                      </div>
                    </li>
                    <li class="sidebar-list" v-if="emp.empdept != '3'"><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/dashboard">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#stroke-file"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Dashboard</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>

                    <li class="sidebar-list" v-else><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/securitydashboard">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#advance"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Security Dashboard</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>



                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#star"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Master</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li><router-link to="/departments">Departments</router-link></li>
                        <li><router-link to="/users">Users</router-link></li>
                        <li><router-link to="/rooms">Meeting Rooms</router-link></li>
                        <li><router-link to="/vehicles">Vehicles</router-link></li>
                        <li><router-link to="/documents">documents</router-link></li>
                      </ul>
                    </li>


                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                      href="#">
                      <svg class="stroke-icon">
                        <use href="../../assets/svg/icon-sprite.svg#orders"></use>
                      </svg>
                      <svg class="fill-icon">
                        <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                      </svg><span class="lan-3">Visitor List</span>
                      <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                    </a>
                    <ul class="sidebar-submenu" style="display: none;">
                      <li><router-link to="/visitorlist">All Visitor</router-link></li>
                      <!-- <li><router-link to="/createEmployeeGatepass">Employee</router-link></li> -->
                    </ul>
                  </li>                    







                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#orders"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Gatepass</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li><router-link to="/gatepass">Visitor</router-link></li>
                        <li><router-link to="/createEmployeeGatepass">Employee</router-link></li>
                        <li><router-link to="/securitygatepass">Security Gatepass</router-link></li>
                      </ul>
                    </li>












                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                      href="#">
                      <svg class="stroke-icon">
                        <use href="../../assets/svg/icon-sprite.svg#orders"></use>
                      </svg>
                      <svg class="fill-icon">
                        <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                      </svg><span class="lan-3">Work Permit</span>
                      <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                    </a>
                    <ul class="sidebar-submenu" style="display: none;">
                      <li><router-link to="/workpermit">Work Permit</router-link></li>
                    </ul>
                  </li>










                    <li class="sidebar-list"><i class="fa fa-thumb-tack"> </i><a class="sidebar-link sidebar-title"
                        href="#">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#clock"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-home"></use>
                        </svg><span class="lan-3">Room Reservation</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </a>
                      <ul class="sidebar-submenu" style="display: none;">
                        <li><router-link to="/meetingroombook">Reservation</router-link></li>
                        <li><router-link to="/calender">Calender</router-link></li>
                      </ul>
                    </li>


                    <li class="sidebar-list"><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/vehicalrequest">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#new-order"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Vehical Request</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>

                    <li class="sidebar-list"><i class="fa fa-thumb-tack"></i>
                      <router-link class="sidebar-link sidebar-title link-nav" to="/securitydashboard">
                        <svg class="stroke-icon">
                          <use href="../../assets/svg/icon-sprite.svg#advance"></use>
                        </svg>
                        <svg class="fill-icon">
                          <use href="../../assets/svg/icon-sprite.svg#fill-file"></use>
                        </svg><span>Security Dashboard</span>
                        <div class="according-menu"><i class="fa fa-angle-right"></i></div>
                      </router-link>
                    </li>
                  </div>
                </div>
              </div>
            </div>
            <div class="simplebar-placeholder" style="width: auto; height: 2055px;"></div>
          </div>
        </ul>
        <div class="right-arrow" id="right-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" class="feather feather-arrow-right">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg></div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss">
@import "../../assets/scss/utils/_variables.scss"; //Here i add extra "./"(current directory) 
@import "../../assets/scss/components/_scrollbar.scss"; //Here i add extra "./"(current directory)</style>

<style>
.simplebar-wrapper {
  overflow-y: hidden;
  overflow-x: hidden;
}

.simplebar-mask {
  top: 0;
}
</style>

<script>

import axios from 'axios';
import { nextTick } from 'vue';
export default {
  name: 'Header',
 mounted() {
   
    console.log(this.$route );
    
    if (localStorage['_emp_token']) {
      this.getUserDetails();
      // this.fetchNotifications();
    } else if (localStorage['token']) {
      this.$router.push({ name: "visitorpage" });
    }
    //  else if (this.$route.path == '/login') {  // Added leading slash
    //     // Don't redirect if we're already on login page
    //     return;
    // } else {
    //     this.$router.push({ name: "register" });
    // }
  
},
  data() {
    return {
      emp: { name: '', dept: '', empcode: '', role: '' },
      otp: '',
      sidebar_status: true,
      notifications: [],
      employeeNotifications:[],
      visitorNotifications:[],
      activeTab: 'all'
    }
  },
  computed: {
    // employeeNotifications() {
    //   return this.notifications.filter(notification =>
    //     notification.employee_name && notification.employee_name.trim() !== '');
    // },
    // visitorNotifications() {
    //   return this.notifications.filter(notification =>
    //     !notification.employee_name ||
    //     notification.employee_name.trim() === '' ||
    //     notification.visitor_name);
    // }
  },
  methods: {
    sidebar_btn() {
      this.sidebar_status = !this.sidebar_status;
      if (this.sidebar_status)
        $("#pageWrapper").toggleClass("sidebar_closed");
      else
        $("#pageWrapper").addClass("sidebar_closed");
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('_emp_token');
      window.location.href = this.$cur_host + 'login';
    },
    getVisitorImagePath(imageName) {
      if (!imageName) return null;
      // Use the correct path based on your application structure
      return `/assets/images/visitors/${imageName}`;
    },
    getUserDetails() {
      const self = this;

      if (localStorage['_emp_token']) {
        axios.post('getEmpDetails', { token: localStorage['_emp_token'] })
          .then(function (response) {
            if (response.data.is === 1) {
                self.emp = response.data.emp;
                if(self.$route.name=='' || self.$route.name==undefined)
                    self.$router.push({ name: "dashboard" });
            } else {
              localStorage.removeItem('_emp_token');
              self.$swal("Session Expired, Please Login");
              self.$router.push({ name: "login" });
            }
          })
          .catch(function (error) {
            console.error('Error fetching user details:', error);
            self.$router.push({ name: "login" });
          });
      }
    },
    // fetchNotifications() {
    //   const self = this;

    //   // Using the correct token for API call
    //   const token = localStorage['_emp_token'] || localStorage['token'];

    //   if (!token) return;

    //   axios.post('getDashboard', { token: token })
    //     .then(function (response) {
    //       // Direct assignment from response data
    //       if (response.data && response.data.notification && Array.isArray(response.data.notification)) {
    //         self.notifications = response.data.notification;
    //         console.log('Notifications loaded:', self.notifications.length);
    //       } else {
    //         console.warn('Invalid notification data structure:', response.data);
    //         self.notifications = [];
    //       }
    //     })
    //     .catch(function (error) {
    //       console.error('Error fetching notifications:', error);
    //       self.notifications = []; // Empty array instead of fallback data
    //     });
    // },
    // getVisitorDisplayName(notification) {
    //   return notification.visitor_name || 'Visitor';
    // },
    // getDisplayName(notification) {
    //   // First check if it's an employee notification
    //   if (notification.employee_name && notification.employee_name.trim() !== '') {
    //     return notification.employee_name;
    //   }
    //   // Otherwise it's a visitor notification
    //   return notification.visitor_name || 'Visitor';
    // },

    // getInitial(notification) {
    //   // For employee notifications
    //   if (notification.employee_name && notification.employee_name.trim() !== '') {
    //     return notification.employee_name.charAt(0).toUpperCase();
    //   }
    //   // For visitor notifications
    //   return notification.visitor_name ?
    //     notification.visitor_name.charAt(0).toUpperCase() : 'V';
    // },
    // isEmployeeNotification(notification) {
    //   return notification.employee_name && notification.employee_name.trim() !== '';
    // },
    // setActiveTab(tab) {
    //   this.activeTab = tab;
    // },
    // checkAllNotifications() {
    //   const self = this;

    //   if (this.notifications.length === 0) return;

    //   const notificationIds = this.notifications
    //     .filter(n => n.read === "0" || n.read === 0)
    //     .map(n => n.id);

    //   if (notificationIds.length === 0) return;

    //   const token = localStorage['_emp_token'] || localStorage['token'];

    //   axios.post('markNotificationsAsRead', {
    //     token: token,
    //     notificationIds: notificationIds
    //   })
    //     .then(response => {
    //       if (response.data && response.data.success) {
    //         // Update local state by refreshing the notifications
    //         self.fetchNotifications();
    //         self.$swal("Success", "All notifications marked as read", "success");
    //       }
    //     })
    //     .catch(error => {
    //       console.error('Error marking notifications as read:', error);
    //       self.$swal("Error", "Failed to mark notifications as read", "error");
    //     });
    // }
  }
}
</script>